import { FullLoading } from '@components/index';
import { createFileRoute, redirect } from '@tanstack/react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/organizations/new')({
  // Always fetch fresh data — no caching on this route
  staleTime: 0,
  beforeLoad: ({ context }) => {
    if (context.authentication.status === 'PENDING') return;

    // Redirect to login if user is not authenticated
    if (context.authentication.status === 'UNAUTHENTICATED') {
      throw redirect({ to: '/login' });
    }

    // Only global SuperAdmins may create organizations
    if (context.authentication.status === 'AUTHENTICATED' && !context.authentication.user.is_super_admin) {
      throw redirect({ to: '/unauthorized' });
    }
  },
  loader: () => ({}),
  pendingComponent: () => {
    const { t } = useTranslation('orgs');

    return <FullLoading addEllipsis label={t('fetching')} />;
  },
});
